import React from 'react';
import {Modal} from 'react-bootstrap';
import './index.css';

export default function ModalDommus({children, ...props}) {

	return <Modal 
		show={props.open} 
		onHide={props.close} 
		size={props.size || "lg"}
		centered
		backdrop={(props.backdrop || true)}
		style={{
			zIndex: props.zindex ||'1040',
			paddingRight: '17px',
			display: 'block'
		}}
		onShow={() => props.callbackAberturaModal && props.callbackAberturaModal()}
	>
		<Modal.Header closeButton={!(props.naoPermiteFecharModal == true)}>
			<Modal.Title><h2>{props.titulo}</h2></Modal.Title>
		</Modal.Header>
		<Modal.Body className={props.classeBody || ''}>
			<div className={`conteudo ${props.classe || ''}`}>
				{props.content}
				{children}
			</div>
		</Modal.Body>
	</Modal>;
}
